// ** React Imports
import { lazy } from 'react';

const EmailLogRoutes = [
  {
    path: 'settings/email-logs',
    component: lazy(() => import('views/email-logs')),
  },
];

export default EmailLogRoutes;
